import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

interface QualityKpi { readonly label: string; readonly value: number; readonly trend: string; }

export function QualityDashboardPage(): ReactNode {
  const { token } = useAuth();
  const { t } = useTranslation();
  const [kpis, setKpis] = useState<QualityKpi[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ items: QualityKpi[] }>('/v1/quality/dashboard', { token })
      .then((r) => { if (alive) setKpis(r.items); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!kpis) return <p>{t('common.loading')}</p>;
  return (
    <main aria-label="quality-dashboard">
      <h1>{t('quality.dashboard.title')}</h1>
      <div role="list" aria-label="kpi-tiles">
        {kpis.map((k) => (
          <div key={k.label} role="listitem">
            <strong>{k.label}</strong>
            <span>{k.value}</span>
            <span>{k.trend}</span>
          </div>
        ))}
      </div>
    </main>
  );
}
